<template>
    <div>
      <h4>Chat discussion sujets</h4>
        
      <data-table
        :data-source="subjects"
        :headers="headers"
        table-class="table-striped table-hover"
      >
        <template slot="actions">
          <a
            href="javascript:void(0)"
            class="btn btn-outline-primary btn-icon"
            data-toggle="modal"
            data-target="#add-chat-subject"
          >
            <i class="icofont icofont-plus" />
          </a>
        </template>
      </data-table>
            
      <modal
        title="Ajout d'un sujet de discussion du Chat"
        id="add-chat-subject"
        :footer="false"
      >
        <form
          class="form-horizontal"
          @submit.prevent="adding"
        >
          <div
            class="alert alert-danger"
            v-if="has_error"
          >
            {{ error_msg }}
          </div>
          <div class="form-group">
            <label for="add-libelle">Libelle</label>
            <input
              id="add-libelle"
              name="add-libelle"
              type="text"
              class="form-control"
              v-model="libelle"
            >
          </div>
          <div class="form-group">
            <label for="add-code">Code</label>
            <input
              id="add-code"
              name="add-code"
              type="text"
              class="form-control"
              v-model="code"
            >
          </div>
          <div class="form-group">
            <label for="add-agents">Agents</label>
            <select 
              id="add-agents"
              name="add-agents"
              v-model="agents"
              multiple
              class="form-control" 
              v-select="{placeholder: 'Selectrionez les agents de cette discussion'}"
            >
              <option />
              <option
                v-for="(item, index) in users"
                :key="index"
                :value="item.uid"
              >
                {{ item.fullname }}
              </option>
            </select>
          </div>
          <div class="form-group text-right">
            <button
              type="submit"
              class="btn btn-primary"
            >
              Ajouter
            </button>
          </div>
        </form>
      </modal>
    
      <modal
        title="Modification du sujet de discussion du chat"
        id="update-chat-subject"
        :footer="false"
      >
        <form
          class="form-horizontal"
          @submit.prevent="editing"
        >
          <div
            class="alert alert-danger"
            v-if="has_error"
          >
            {{ error_msg }}
          </div>
          <div class="form-group">
            <label for="update-libelle">Libelle</label>
            <input
              id="update-libelle"
              name="update-libelle"
              type="text"
              class="form-control"
              v-model="libelle"
            >
          </div>
          
          <div class="form-group">
            <label for="update-code">Code</label>
            <input
              id="update-code"
              name="update-code"
              type="text"
              class="form-control"
              v-model="code"
            >
          </div>
          
          <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="update-agents">Agents</label>
                    <select 
                      id="update-agents"
                      name="update-agents"
                      v-model="agents"
                      multiple
                      class="form-control" 
                      v-select="{placeholder: 'Selectrionez les agents de cette discussion'}"
                    >
                        <option />
                        <option
                          v-for="(item, index) in users"
                          :key="index"
                          :value="item.uid"
                        >
                          {{ item.fullname }}
                        </option>
                    </select>
                </div>
            </div>
          </div>
          
         
          <div class="form-group text-right">
            <button
              type="submit"
              class="btn btn-primary"
            >
              Enregistrer
            </button>
          </div>
        </form>
      </modal>
    </div>
  </template>
    
    <script>
    import {mapGetters, mapMutations} from 'vuex'
    import DataTable from '../../../components/dataTable/local.vue'
    import { COMPONENT_TYPE, TEXT_TYPE } from '../../../components/dataTable/dataType'
    import Modal from '../../../components/modal.vue'
    import { ADD_CHAT_SUBJECT, UPDATE_CHAT_SUBJECT } from '../../../graphql/chat'
    const Actions = () => import('../../../components/chat/subjectAction.vue')
    export default {
        components: { DataTable, Modal},
        data(){
            return {
                libelle: null,
                code: null,
                agents: [],
                has_error: false,
                error_msg: null
            }
        },
        watch: {
            selectedType: {
                handler(){
                    console.log('Selected subject change')
                    if(this.selectedType !== null) {
                        this.libelle = this.selectedType.libelle
                        this.agents =  JSON.parse(this.selectedType.agents)
                        this.code = this.selectedType.code
                    }
                },
                deep: true
            }
        },
        methods: {
            ...mapMutations({
                done: 'DONE',
                setSelectedObject: 'SET_SELECTED_OBJECT'
            }),
            initForm(){
                this.setSelectedObject(null)
                this.libelle = null
                this.agents = []
                this.code = null
                this.has_error = false
                this.error_msg = null
            },
            adding(){
                let data = {
                    libelle: this.libelle,
                    agents: JSON.stringify(this.agents),
                    code: this.code
                }
                this.$apollo.mutate({
                    mutation: ADD_CHAT_SUBJECT,
                    variables: {
                        "subject": {
                            ...data
                        }
                    },
                    update: (d) => {
                        console.log(d)
                        console.log(`Type event ${this.libelle} add successfully`)
                    }
                  }).then(() => {
                    this.initForm()
                    this.done()
                }).catch((error) => {
                    console.error(error)
                    this.has_error = true
                    this.error_msg = error
                })
            },
            editing(){
                console.log(this.agents)
                // return 
                let data = {
                    libelle: this.libelle,
                    agents: JSON.stringify(this.agents),
                    code: this.code
                }
                this.$apollo.mutate({
                    mutation: UPDATE_CHAT_SUBJECT,
                    variables: {
                        "subject": {
                            ...data
                        },
                        "uid": this.selectedType.uid
                    },
                    update: (d) => {
                        console.log(d)
                        console.log(`Chat subject ${this.libelle} on ${this.selectedType.uid} updated successfully`)
                    }
                  }).then(() => {
                    this.initForm()
                    this.done()
                }).catch((error) => {
                    console.error(error)
                    this.has_error = true
                    this.error_msg = error
                })
            }
        },
        computed: {
            ...mapGetters({
                subjects: 'chat/subjects',
                users: 'auth/activAgents',
                selectedType: 'selectedObject'
            }),
            headers(){
                return [
                    {label: 'ID', name: 'uid', type: TEXT_TYPE},
                    {label: 'Libelle', name: 'libelle', type: TEXT_TYPE},
                    {label: 'Code', name: 'code', type: TEXT_TYPE},
                    {label: 'Agents', name: 'agents', type: TEXT_TYPE},
                    {label: 'Actions', name: 'action', type: COMPONENT_TYPE, component: Actions}
                ]
            }
        }
    }
    </script>
    
    <style>
    
    </style>